/**
 * Computes whether a query should be enabled based on authentication state
 * @param isPublicEventReportPage - Whether the current page is a public event report
 * @param accessToken - The current access token (if any)
 * @param refreshToken - The current refresh token (if any)
 * @param optionsEnabled - The enabled option passed to the query
 * @returns The computed enabled value for the query
 */
export const computeQueryEnabled = ({
  isPublicEventReportPage,
  accessToken,
  refreshToken,
  optionsEnabled,
}: {
  isPublicEventReportPage: boolean;
  accessToken?: string;
  refreshToken?: string;
  optionsEnabled?: boolean;
}): boolean | undefined => {
  if (isPublicEventReportPage) {
    // For public pages, respect the options.enabled
    return optionsEnabled;
  } else if (optionsEnabled === false) {
    // If options.enabled is explicitly false, respect it (missing params, etc)
    return false;
  } else if (!accessToken && !!refreshToken) {
    // If no accessToken but has refreshToken, enable to trigger refresh flow
    return true;
  } else {
    // Default to true if not explicitly disabled
    return optionsEnabled ?? true;
  }
};
